'use client';

import { usePathname } from 'next/navigation';

import { FeedbackForm } from '@/shared/components/feedbackForm';
import { FeedbackFormProps } from '@/shared/components/feedbackForm/ui/types';
import { MainContainer } from '@/shared/components/mainContainer';
import {
  standardFormFields,
  partnersFormFields,
} from '@/shared/constants/formsFields';

export const FeedbackFormContainer = ({
  translations,
  locale,
  images,
}: Pick<FeedbackFormProps, 'locale' | 'images' | 'translations'>) => {
  const pathname = usePathname();
  const [_, page] = pathname
    .replace(new RegExp(`^/${locale}(/|$)`), '')
    .split('/');

  return (
    page !== 'platform-manager' && (
      <section className="mx-auto mb-[100px] max-w-[1440px] max-sm:mb-16">
        <MainContainer>
          <FeedbackForm
            fields={
              page === 'partners'
                ? [...partnersFormFields]
                : [...standardFormFields]
            }
            translations={translations}
            locale={locale}
            images={images}
          />
        </MainContainer>
      </section>
    )
  );
};
